import { useState } from 'hooks'
import $ from 'jquery'
import Sortable from 'sortablejs'

import { textAnalytics } from './constant'
import { getTextAnalyticsEditorSelectors } from './selector'

const { questionSettings } = textAnalytics

type State = {
	editorQuestions: HTMLElement
	editorAvailableQuestions: HTMLElement
	editorAssignedQuestions: HTMLElement
}

export const TextAnalyticsEditor = (() => {
	const { state, setState } = useState<State>()

	const handleAjax = (link: string, questionIds: string[]) => {
		// @ts-ignore
		$.nette.ajax({
			url: link.replace('-ids=0', `-ids=${questionIds.join(',')}`),
		})
	}

	const initSortable = () => {
		const { editorAvailableQuestions, editorAssignedQuestions } = state
		if (!editorAvailableQuestions || !editorAssignedQuestions) {
			return null
		}

		const saveHandle = editorAssignedQuestions.getAttribute(questionSettings.editorQuestionSaveHandler)
		if (!saveHandle) {
			return null
		}

		const sortableAvailable = new Sortable(editorAssignedQuestions, {
			group: 'sharedCtEditor',
			animation: 150,
			draggable: 'div',
			store: {
				get: () => [],
				set: (e: Sortable) => {
					handleAjax(saveHandle, getAssignedBlocksIdsFromSortable(e))
				},
			},
			onAdd: (e: { item: any }) => {
				const { item } = e
				const questionId = item.getAttribute(questionSettings.editorQuestion)

				if (!questionId) {
					return
				}
				handleAjax(saveHandle, [questionId])
			},
			onRemove: (e: { item: any }) => {
				const { item } = e
				const questionId = item.getAttribute(questionSettings.editorQuestion)

				if (!questionId) {
					return
				}
				handleAjax(saveHandle, [questionId])
			},
		})

		const sortableAssigned = new Sortable(editorAvailableQuestions, {
			group: 'sharedCtEditor',
			animation: 150,
			draggable: 'div',
		})

		if (!sortableAssigned || !sortableAvailable) {
			return null
		}
		return {
			sortableAvailable,
			sortableAssigned,
		}
	}

	const getAssignedBlocksIdsFromSortable = (sortable: Sortable): string[] =>
		Array.from(sortable.el.children).map((element: Element) => element.getAttribute('data-editor-question') as string)

	const init = () => {
		setState({ ...getTextAnalyticsEditorSelectors() })
		initSortable()
	}

	return {
		init,
	}
})()
